const themeVuetify = {
  primary: '#0086ff',
  secondary: '#585f62',
  tertiary: '#ff8a00',
  accent: '#90A4AE',
  error: '#EF5350',
};

export default themeVuetify;
